
import './App.css';
import Home from './page/Home';

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
